import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BUILTIN_CATEGORIES = [
  { value: 'acougue', label: 'Açougue' },
  { value: 'padaria', label: 'Padaria' },
  { value: 'flv', label: 'FLV (Frutas, Legumes e Verduras)' },
  { value: 'mercearia', label: 'Mercearia' },
  { value: 'bebidas', label: 'Bebidas' },
  { value: 'frios_laticinios', label: 'Frios e Laticínios' },
  { value: 'limpeza', label: 'Limpeza' },
  { value: 'higiene', label: 'Higiene e Perfumaria' },
  { value: 'outros', label: 'Outros' },
];

let cache = BUILTIN_CATEGORIES;
let inflight = null;
const listeners = new Set();
const notify = () => listeners.forEach((fn) => fn(cache));

export const getCategories = () => cache;
export const categoryLabelOf = (v) => (cache.find((c) => c.value === v) || {}).label || v || '—';

export const loadCategories = () => {
  if (!inflight) {
    inflight = axios.get(`${API}/products/categories`, { withCredentials: true })
      .then((r) => { cache = r.data; notify(); return cache; })
      .catch(() => cache)
      .finally(() => { inflight = null; });
  }
  return inflight;
};

export const createCategory = async (label) => {
  const r = await axios.post(`${API}/products/categories`, { label }, { withCredentials: true });
  cache = r.data.categories; notify();
  return r.data;
};

export const deleteCategory = async (value) => {
  const r = await axios.delete(`${API}/products/categories/${value}`, { withCredentials: true });
  cache = r.data.categories; notify();
  return cache;
};

export const useProductCategories = () => {
  const [cats, setCats] = useState(cache);
  useEffect(() => {
    listeners.add(setCats);
    loadCategories();
    return () => listeners.delete(setCats);
  }, []);
  return cats;
};
